/* eslint-disable camelcase */

export interface Ga4BootstrapOptions {
  measurementId: string;
  client: string;
  debug: boolean;
}

export function initGa4(options: Ga4BootstrapOptions): void {
  const { measurementId, client, debug } = options;

  const globalRecord = globalThis as unknown as Record<string, unknown>;
  globalRecord['dataLayer'] ??= [];
  globalRecord['gtag'] = function gtag(): void {
    // eslint-disable-next-line prefer-rest-params
    (globalRecord['dataLayer'] as unknown[]).push(arguments);
  };

  const gtagFunction = globalRecord['gtag'] as (
    ...arguments_: unknown[]
  ) => void;
  gtagFunction('js', new Date());
  gtagFunction('set', 'user_properties', { client });
  gtagFunction('config', measurementId, {
    client,
    send_page_view: false,
    ...(debug && { debug_mode: true }),
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.append(script);
}
